import * as React from 'react';
import {useSelector} from 'react-redux';
import {selectAgencyData} from 'src/selectors/agency';

/**
 * Hook to get agency API headers for Ask AI API requests
 * @returns Object containing headers
 */
export function useAgencyApiHeaders() {
  const {id: agencyId} = useSelector(selectAgencyData);

  const headers = React.useMemo((): Record<string, string> => {
    if (!agencyId) {
      return {};
    }
    return {
      'x-agency-id': String(agencyId),
    };
  }, [agencyId]);

  return headers;
}
